import type { Plugin } from 'vue';
import { useEventBus } from '@/app/core/event-bus';
import { useAnnouncementsStore } from './stores';

export function createAnnouncements(): Plugin {
  return {
    install() {
      const store = useAnnouncementsStore();
      const eventBus = useEventBus();

      eventBus.on('appInitialized', async () => {
        await store.fetch();
      });
    },
  };
}

export * from './components';
export * from './stores';
